import { MantineStyleProp, Title, TitleOrder, TitleSize } from "@mantine/core";
import { ReactNode } from "react";

export const Header = (props: { size?: TitleSize; order?: TitleOrder; children: ReactNode; style?: MantineStyleProp }) => {
    return (
        <Title
            order={props.order ?? 4}
            size={props.size ?? "h3"}
            p="sm"
            style={{ backgroundColor: "#00000020", borderRadius: "var(--mantine-radius-sm)" }}
        >
            {props.children}
        </Title>
    );
};
